import PropTypes from "prop-types";
import React from "react";

import rectangle34 from '../../assets/images/university/rectangle-34.png';
import rectangle33 from '../../assets/images/university/rectangle-33.png';
import rectangle32 from '../../assets/images/university/rectangle-32.png';
import rectangle31 from '../../assets/images/university/rectangle-31.png';

const Frame = ({
    property1,
    className,
    rectangle = rectangle31,
    img = rectangle32,
    rectangle1 = rectangle34,
    rectangle2 = rectangle33,
    frame = "frame-124.svg",
}) => {
    return (
        <div className={`frame ${className}`}>
            <div className="overlap-group">
                <div className="div">
                    {property1 === "variant-2" && <img className="rectangle" alt="Rectangle" src="image.png" />}

                    <img className="img" alt="Rectangle" src={property1 === "default" ? rectangle : "rectangle-31-2.png"} />
                    <img className="rectangle" alt="Rectangle" src={property1 === "variant-2" ? "rectangle-33-2.png" : img} />
                    {property1 === "default" && (
                        <>
                            <img className="img" alt="Rectangle" src={rectangle1} />
                            <img className="rectangle" alt="Rectangle" src={rectangle2} />
                        </>
                    )}
                </div>
                <img className="img-2" alt="Frame" src={property1 === "variant-2" ? "image.svg" : frame} />
            </div>
        </div>
    );
};

Frame.propTypes = {
    property1: PropTypes.oneOf(["variant-2", "default"]),
    rectangle: PropTypes.string,
    img: PropTypes.string,
    rectangle1: PropTypes.string,
    rectangle2: PropTypes.string,
    frame: PropTypes.string,
};

export default Frame
